import { render } from "./PdfModal.vue?vue&type=template&id=478cdaa1"
import script from "./PdfModal.vue?vue&type=script&lang=js"
export * from "./PdfModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/documedias/gitlab/virtuell/ispad2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__